import React, { createContext, useContext, useState } from 'react';

const ManufacturingExpansionContext = createContext();

export function ManufacturingExpansionProvider({ children }) {
  const [expandedProducts, setExpandedProducts] = useState(new Set());

  const toggleProduct = (productId) => {
    setExpandedProducts(prev => {
      const newSet = new Set(prev);
      if (newSet.has(productId)) {
        newSet.delete(productId);
      } else {
        newSet.add(productId);
      }
      return newSet;
    });
  };

  const expandProduct = (productId) => {
    setExpandedProducts(prev => new Set([...prev, productId]));
  };

  const collapseProduct = (productId) => {
    setExpandedProducts(prev => {
      const newSet = new Set(prev);
      newSet.delete(productId);
      return newSet;
    });
  };

  const expandAll = (productIds) => {
    setExpandedProducts(new Set(productIds));
  };

  const collapseAll = () => {
    setExpandedProducts(new Set());
  };

  const isExpanded = (productId) => {
    return expandedProducts.has(productId);
  };

  const value = {
    expandedProducts,
    toggleProduct,
    expandProduct,
    collapseProduct,
    expandAll,
    collapseAll,
    isExpanded
  };

  return (
    <ManufacturingExpansionContext.Provider value={value}>
      {children}
    </ManufacturingExpansionContext.Provider>
  );
}

export function useManufacturingExpansion() {
  const context = useContext(ManufacturingExpansionContext);
  if (context === undefined) {
    throw new Error('useManufacturingExpansion must be used within a ManufacturingExpansionProvider');
  }
  return context;
} 